var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgForwardMobile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 -2048 2048.55 2048",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    transform: "scale(1, -1)",
    d: "M1073 384l-57 -56l72 -72h-256v128h241zM1216 128l128 -128h-832q-27 0 -50 10t-40.5 27.5t-27.5 40.5t-10 50v1792q0 27 10 50t27.5 40.5t40.5 27.5t50 10h1024q27 0 50 -10t40.5 -27.5t27.5 -40.5t10 -50v-1264l-128 -128v1392h-1024v-1792h704zM2029 610l-557 -557 l-269 269l90 91l179 -179l467 467z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgForwardMobile);
export default __webpack_public_path__ + "static/media/forward-mobile.47a21fd7.svg";
export { ForwardRef as ReactComponent };